export const privacyPolicy = [
  {
    "text": "What information does the Application obtain and how is it used?",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "User Provided Information",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "The Application obtains the information you provide when you download and register the Application. Registration with us is optional. However, please keep in mind that you may not be able to use some of the features offered by the Application unless you register with us.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "When you register with us and use the Application, you generally provide (a) your name, email address, age, user name, password and other registration information; (b) transaction-related information, such as when you make purchases, respond to any offers, or download or use applications from us; (c) information you provide us when you contact us for help; (d) credit card information for purchase and use of the Application, and; (e) information you enter into our system when using the Application, such as contact information and project management information.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "We may also use the information you provided us to contact your from time to time to provide you with important information, required notices and marketing promotions.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Automatically Collected Information",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "In addition, the Application may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile devices unique device ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browsers you use, and information about the way you use the Application.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Does the Application collect precise real time location information of the device?",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "When you visit the mobile application, we may use GPS technology (or other similar technology) to determine your current location in order to determine the city you are located within and display a location map with relevant advertisements. We will not share your current location with other users or partners.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "If you do not want us to use your location for the purposes set forth above, you should turn off the location services for the mobile application located in your account settings or in your mobile phone settings and/or within the mobile application.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Do third parties see and/or have access to information obtained by the Application?",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "Yes. We will share your information with third parties only in the ways that are described in this privacy statement.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "We may disclose User Provided and Automatically Collected Information:",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "as required by law, such as to comply with a subpoena, or similar legal process;",
    "fontSize": "14px",
    "isChildOfLi": true
  },
  {
    "text": "when we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;",
    "fontSize": "14px",
    "isChildOfLi": true
  },
  {
    "text": "with our trusted services providers who work on our behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.",
    "fontSize": "14px",
    "isChildOfLi": true
  },
  {
    "text": "if Gear Games Inc. is involved in a merger, acquisition, or sale of all or a portion of its assets, you will be notified via email and/or a prominent notice on our Web site of any change in ownership or uses of this information, as well as any choices you may have regarding this information.",
    "fontSize": "14px",
    "isChildOfLi": true
  },
  {
    "text": "What are my opt-out rights?",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "You can stop all collection of information by the Application easily by uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network. You can also request to opt-out via email, at hello@geargames.com.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Data Retention Policy, Managing Your Information",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "We will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. We will retain Automatically Collected information for up to 24 months and thereafter may store it in aggregate. If you’d like us to delete User Provided Data that you have provided via the Application, please contact us at hello@geargames.com and we will respond in a reasonable time. Please note that some or all of the User Provided Data may be required in order for the Application to function properly.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Children",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "We do not use the Application to knowingly solicit data from or market to children under the age of 13. If a parent or guardian becomes aware that his or her child has provided us with information without their consent, he or she should contact us at hello@geargames.com. We will delete such information from our files within a reasonable time.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Security",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "We are concerned about safeguarding the confidentiality of your information. We provide physical, electronic, and procedural safeguards to protect information we process and maintain. For example, we limit access to this information to authorized employees and contractors who need to know that information in order to operate, develop or improve our Application. Please be aware that, although we endeavor provide reasonable security for information we process and maintain, no security system can prevent all potential security breaches.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Changes",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "This Privacy Policy may be updated from time to time for any reason. We will notify you of any changes to our Privacy Policy by posting the new Privacy Policy here and informing you via email. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Your consent",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "By using the Application, you are consenting to our processing of your information as set forth in this Privacy Policy now and as amended by us. \"Processing,” means using cookies on a computer/handheld device or using or touching information in any way, including, but not limited to, collecting, storing, deleting, using, combining and disclosing information, all of which activities will take place in the Vietnam. If you reside outside Vietnam your information will be transferred, processed and stored there under Vietnam privacy standards.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": " ",
    "fontSize": "14px",
    "isChildOfLi": false
  },
  {
    "text": "Contact us",
    "fontSize": "17px",
    "isChildOfLi": false
  },
  {
    "text": "If you have any questions regarding privacy while using the Application, or have questions about our practices, please contact us via email at hello@geargames.com.",
    "fontSize": "14px",
    "isChildOfLi": false
  },
]